import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/product';
import $P from 'plugins/tfs/platformConfigs/integrationMaps/product';
import * as React from 'react';

export default class Info extends React.Component {
  render() {
    const { product } = this.props;

    return (
      <div className='info'>
        {$ST.PRODUCT_CODE}: {product.base_code}-
        {product.attributes[$P.PRODUCT_CODE]}
        <ul
          dangerouslySetInnerHTML={{
            __html: product.attributes[$P.PRODUCT_INFO],
          }}
        ></ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/detail/Info.js